import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Icon } from 'ecrion-components';
import NavBar from '../NavBar';
import Common from '../Common';
import serviceImage from './serviceImage.png';
import Button from '../../core/Button';
import { withStyles, createStyles } from '@material-ui/core/styles';
import useProvider from '../../core/EcrionProvider/useProvider';
import PageProvider from '../Provider';

var styles = function styles(theme) {
  return createStyles({
    root: {
      textAlign: 'center',
      margin: 'auto',
      height: 'calc(100vh - 50px)',
      maxWidth: 640 - theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      '& img': {
        maxWidth: 200
      }
    },
    content: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: 12
    },
    darkText: {
      color: '#FFF'
    },
    lightText: {
      color: '#000'
    },
    hiddenContent: {
      textAlign: 'left'
    },
    buttonStyle: {
      marginTop: theme.spacing(3),
      borderRadius: '6px'
    },
    '@keyframes fadeMeIn': {
      from: {
        opacity: 0
      },
      '50%': {
        opacity: 0
      },
      to: {
        opacity: 1
      }
    },
    fadeIn: {
      opacity: 0,
      animationName: '$fadeMeIn',
      animationDuration: '2s',
      animationFillMode: 'forwards'
    }
  });
};
/**
 * @param {import('./types').PageErrorProps & import('@material-ui/core').WithStyles<typeof styles>} props
 */


var Error = function Error(_ref) {
  var classes = _ref.classes,
      dark = _ref.dark,
      hideNavBar = _ref.hideNavBar,
      title = _ref.title,
      message = _ref.message,
      details = _ref.details,
      onClick = _ref.onClick,
      buttonText = _ref.buttonText,
      image = _ref.image;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDetailsVisible = _useState2[0],
      toggleDetailsVisibility = _useState2[1];

  var providerProps = useProvider();
  var history = providerProps.routes && providerProps.routes.history;
  var textClassName = dark ? classes.darkText : classes.lightText;
  var buttonHandler = null;

  if (onClick) {
    buttonHandler = onClick;
  } else {
    if (history && history.goBack) buttonHandler = history.goBack;
  }

  var trimmedTitle = title;
  if (trimmedTitle.length > 100) trimmedTitle = trimmedTitle.substring(0, 100) + '...';
  var imageSrc = serviceImage;
  if (image) imageSrc = image;
  return React.createElement(React.Fragment, null, !hideNavBar && React.createElement(NavBar, null), React.createElement("div", {
    className: classes.fadeIn
  }, React.createElement(Common, {
    margin: "none"
  }, React.createElement(Grid, {
    container: true,
    justify: "center",
    direction: "column",
    className: classes.root
  }, React.createElement(Grid, {
    item: true
  }, React.createElement("img", {
    src: imageSrc
  }), !isDetailsVisible && React.createElement(React.Fragment, null, React.createElement("div", {
    className: classes.content
  }, React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true,
    className: textClassName
  }, trimmedTitle), React.createElement(Typography, {
    className: textClassName
  }, message)), details && React.createElement("div", null, React.createElement(Icon, {
    type: "down",
    label: "View details",
    labelPlacement: "start",
    color: "inherit",
    onClick: function onClick() {
      return toggleDetailsVisibility(function (v) {
        return !v;
      });
    }
  }))), isDetailsVisible && React.createElement("div", {
    className: classes.hiddenContent
  }, React.createElement(Icon, {
    type: "up",
    label: "Hide details",
    labelPlacement: "start",
    color: "inherit",
    onClick: function onClick() {
      return toggleDetailsVisibility(function (v) {
        return !v;
      });
    }
  }), React.createElement("div", {
    className: classes.content
  }, React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true,
    className: textClassName
  }, trimmedTitle), React.createElement(Typography, {
    className: textClassName
  }, details))), buttonHandler && buttonText && React.createElement(Button, {
    className: classes.buttonStyle,
    onClick: buttonHandler
  }, buttonText))))));
};

Error.defaultProps = {
  dark: false,
  title: 'Unexpected Error',
  message: 'Looks like something went wrong on our end. Head back to the home page.',
  details: null,
  hideNavBar: false,
  buttonText: 'Go back'
};
export default withStyles(styles, {
  name: 'ECError'
})(Error);